import type { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import shallow from 'zustand/shallow';
import type { ViewMode } from '../../store';
import { useCcConfig } from '../../store';
import { TabPills } from '../tab-pills';

interface ViewTab {
  key: ViewMode;
  label: string;
  icon: string;
}

/*
 * View-mode pills shown on the events routes. These don't change the route —
 * they switch how the events listing is rendered (board vs. table).
 */
const VIEW_TABS: ViewTab[] = [
  { key: 'board', label: 'Board', icon: 'far fa-th-large' },
  { key: 'table', label: 'Table', icon: 'fal fa-bars' }
];

/*
 * Route-dependent tab-pills rendered in the header, to the left of the user
 * section. On the events routes they toggle the listing's view mode. Renders
 * nothing on routes that have no tabs.
 */
export const NavTabs = (): ReactElement | null => {
  const { pathname } = useLocation();

  const { viewMode, setViewMode } = useCcConfig((v) => ({
    viewMode: v.viewMode,
    setViewMode: v.setViewMode
  }), shallow);

  const showEventsTabs = pathname === '/events' || pathname.startsWith('/events/');

  if (!showEventsTabs) {
    return null;
  }

  return (
    <TabPills
      pills={VIEW_TABS.map((tab) => ({
        key: tab.key,
        icon: tab.icon,
        label: tab.label,
        active: tab.key === viewMode,
        onClick: (): void => {
          setViewMode(tab.key);
        }
      }))}
    />
  );
};
